import { useState } from 'react';
import { useStore } from 'effector-react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { authStore } from 'stores/AuthStore/AuthStore';
import { loginSSOUseCase } from 'useCases/Auth/loginSSOUseCase';
import { Common } from 'utils';
import { keycloak } from '../../keycloak';

export default function AccessPendingPage() {
  const user = useStore(authStore);
  const [loading, setLoading] = useState(false);
  const refresh = async () => {
    setLoading(true);
    try {
      await loginSSOUseCase.execute({ token: keycloak.token || user.token });
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 4, mt: 8 }}>
      <Typography variant="h4" gutterBottom>
        {user.accessStatus === 'Revoked' ? 'Acesso revogado' : 'Aguardando liberação de acesso'}
      </Typography>
      <Typography>
        Seu cadastro foi identificado. Solicite ao administrador responsável a liberação para uma
        franquia.
      </Typography>
      <Typography sx={{ my: 2 }}>
        {user.name} — {user.email}
      </Typography>
      <Stack direction="row" spacing={2}>
        <Button variant="contained" disabled={loading} onClick={refresh}>
          {loading ? 'Verificando...' : 'Verificar acesso'}
        </Button>
        <Button
          onClick={() => {
            Common.setSessionValue('logCookie', null);
            keycloak.logout({ redirectUri: window.location.origin });
          }}
        >
          Sair
        </Button>
      </Stack>
    </Box>
  );
}
